export const switchSizes = Object.freeze({
  SMALL: 'sm',
  LARGE: 'lg',
});

export const defaultSize = switchSizes.LARGE;
